__turbopack_context__.v({
  "active": "R9laJG_active",
  "chips": "R9laJG_chips",
  "label": "R9laJG_label",
  "primary": "R9laJG_primary",
  "tag": "R9laJG_tag",
});
